'use strict';
module.exports = function () {
	return /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g;
};



//////////////////
// WEBPACK FOOTER
// ./~/ansi-regex/index.js
// module id = 306
// module chunks = 0